/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestUtil, TestUtilInterface } from "../TestUtil";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "error",
        type: "bytes",
      },
    ],
    name: "Called",
    type: "event",
  },
  {
    inputs: [],
    name: "libRelayRequestName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "libRelayRequestType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "libRelayRequestTypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "libRelayRequestSuffix",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "callForwarderVerify",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "callForwarderVerifyAndCall",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "ret",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
    ],
    name: "splitRequest",
    outputs: [
      {
        internalType: "bytes32",
        name: "typeHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "suffixData",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "libDomainSeparator",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "libGetChainID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "_ecrecover",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestUtilConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestUtilConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestUtil__factory extends ContractFactory {
  constructor(...args: TestUtilConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<TestUtil> {
    return super.deploy(overrides || {}) as Promise<TestUtil>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TestUtil {
    return super.attach(address) as TestUtil;
  }
  override connect(signer: Signer): TestUtil__factory {
    return super.connect(signer) as TestUtil__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestUtilInterface {
    return new utils.Interface(_abi) as TestUtilInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestUtil {
    return new Contract(address, _abi, signerOrProvider) as TestUtil;
  }
}
